const shippingPointNames = {
  // 1057: 'Umbro',
  1060: 'Blue Ribbon',
  1063: 'Samples',
  1064: 'Wings',
  1065: 'Cortez',
  1067: 'Windrunner',
  // 1068: 'Golf',
  // 1075: 'Converse Boom',
  // 1164: 'Equipment and Promo',
  // 1167: 'Equipment',
  // 1168: 'XPO Eindhoven',
  1175: 'Converse Grobbendonk',
  1264: 'The Court',
  1275: 'Converse Decon',
}

const shippingPointNamesArray = [
  // { value: '1057', label: '1057: Umbro' },
  { value: '1060', label: '1060: Blue Ribbon' },
  { value: '1063', label: '1063: Samples' },
  { value: '1064', label: '1064: Wings' },
  { value: '1065', label: '1065: Cortez' },
  { value: '1067', label: '1067: Windrunner' },
  // { value: '1068', label: '1068: Golf' },
  // { value: '1075', label: '1075: Converse Boom' },
  // { value: '1164', label: '1164: Equipment and Promo' },
  // { value: '1167', label: '1167: Equipment' },
  // { value: '1168', label: '1168: XPO Eindhoven' },
  { value: '1175', label: '1175: Converse Grobbendonk' },
  { value: '1264', label: '1264: The Court' },
  { value: '1275', label: '1275: Converse Decon' },
]

export function getShippingPointName(shippingPointCode: number) {
  return shippingPointNames[shippingPointCode] || '?'
}

export function getShippingPoints() {
  return shippingPointNamesArray
}

export function getSelectedShippingPoints(shippingPointCodes: string[]) {
  return shippingPointCodes
    ? shippingPointNamesArray.filter((spOption) => shippingPointCodes.includes(spOption.value))
    : []
}
